// The container writes assets/runtime-config.js before starting nginx.
// Keep this shape aligned with environment.tpl.ts for normal Angular development.
interface RuntimeEnvironment {
  production: boolean;
  defaultPrimaryAdminPassword: string;
  api: {core: {uri: string; port: string; path: string}};
  softphone: {scheme: string; server: string; port: string; path: string; sipDomain: string};
  stripe: {key: string};
  recaptcha: {key: string};
  footer: {copyrightLabel: string; copyrightStartYear: string; companyName: string; companyEmail: string};
}
const runtime = (window as Window & {__ECMS_CONFIG__?: RuntimeEnvironment}).__ECMS_CONFIG__;
if (!runtime) throw new Error('The server did not provide the eCMS runtime configuration');
export const environment: RuntimeEnvironment = runtime;
